import { render } from "./CommodityHome.vue?vue&type=template&id=47533d18&ts=true"
import script from "./CommodityHome.vue?vue&type=script&lang=ts"
export * from "./CommodityHome.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\winserverroot\\Downloads\\ソース\\netstore-browser-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__